import api from './axios';
import { setAuthToken } from './axios';
import { AxiosError } from 'axios';

const LOGIN_URL = import.meta.env.VITE_LOGIN_URL as string;
const LOGOUT_URL = import.meta.env.VITE_LOGOUT_URL as string;

export function initAuth(): string | null {
    const search = window.location.search;
    const urlToken = search.startsWith('?')
        ? search.slice(1)
        : null;

    if (urlToken) {
        sessionStorage.setItem('jwt_token', urlToken);
        history.replaceState(null, '', window.location.pathname);
    }

    const token = urlToken ?? sessionStorage.getItem('jwt_token');

    if (token) {
        setAuthToken(token);
    }

    return token;
}

export async function checkToken(): Promise<boolean> {
    try {
        await api.get('/Auth/CheckToken');
        return true;
    } catch (error) {
        const status = (error as AxiosError).response?.status;
        if (status === 401 || status === 403) {
            redirectToLogin();
        }
        return false;
    }
}

export function redirectToLogin(): void {
    sessionStorage.removeItem('jwt_token');
    setAuthToken(null);
    window.location.href = LOGIN_URL;
}

export function logout(): void {
    sessionStorage.removeItem('jwt_token');
    setAuthToken(null);
    window.location.href = LOGOUT_URL;
}